import { LuCheck } from 'react-icons/lu';

import { ONBOARDING_WIZARD_STEP_LABELS, ONBOARDING_WIZARD_STEP_ORDER, OnboardingWizardStep } from '../types';

interface Props {
    currentStep: OnboardingWizardStep;
    activeStepOrder: OnboardingWizardStep[];
    disabledStepReasons?: Partial<Record<OnboardingWizardStep, string>>;
    onSelectStep?: (step: OnboardingWizardStep) => void;
}

export const WizardStepNav = ({ currentStep, activeStepOrder, disabledStepReasons = {}, onSelectStep }: Props) => {
    const currentIndex = activeStepOrder.indexOf(currentStep);
    return (
        <ol className="flex flex-col gap-1 p-4">
            {ONBOARDING_WIZARD_STEP_ORDER.map((step, index) => {
                const isCurrent = step === currentStep;
                const disabledReason = disabledStepReasons[step];
                const isDisabled = !!disabledReason;
                const stepIndex = activeStepOrder.indexOf(step);
                const isComplete = !isDisabled && stepIndex >= 0 && stepIndex < currentIndex;
                const canJump = !!onSelectStep && !isDisabled && stepIndex >= 0 && stepIndex <= currentIndex;
                return (
                    <li key={step}>
                        <button
                            type="button"
                            disabled={!canJump}
                            onClick={() => canJump && onSelectStep?.(step)}
                            className={`flex w-full items-center gap-3 rounded px-3 py-2 text-left text-sm transition ${
                                isCurrent
                                    ? 'bg-cocoa-100 text-cocoa-1000 font-medium'
                                    : isDisabled
                                      ? 'text-cocoa-400'
                                      : 'text-cocoa-600 hover:bg-cocoa-50 disabled:hover:bg-transparent'
                            }`}
                        >
                            <span
                                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs ${
                                    isComplete
                                        ? 'bg-cocoa-1000 border-cocoa-1000 text-white'
                                        : isCurrent
                                          ? 'border-cocoa-1000 text-cocoa-1000'
                                          : 'border-cocoa-300 text-cocoa-500'
                                }`}
                            >
                                {isComplete ? <LuCheck className="h-3 w-3" /> : index + 1}
                            </span>
                            <span className="flex min-w-0 flex-col">
                                <span>{ONBOARDING_WIZARD_STEP_LABELS[step]}</span>
                                {disabledReason && (
                                    <span className="text-cocoa-500 mt-0.5 text-xs leading-snug font-normal">
                                        {disabledReason}
                                    </span>
                                )}
                            </span>
                        </button>
                    </li>
                );
            })}
        </ol>
    );
};
